import api from '@services/api';
import { FileResponse } from '../models/period';

/**
 * <p>
 * API endpoints that cover all sharing related CRUD calls
 */
export const sharingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    exportPeriodFile: builder.mutation<void, string>({
      query: (period: string) => ({
        url: encodeURI(`/indirect/period-file/export?period=${period}`),
        method: 'POST',
      }),
      invalidatesTags: ['PeriodFile'],
    }),
    periodFileByPeriod: builder.query<FileResponse, number>({
      query: (period: number) => ({
        url: encodeURI(`/indirect/period-file/byPeriod?periodId=${period}`),
      }),
      providesTags: ['PeriodFile'],
    }),
  }),
});

export const { useExportPeriodFileMutation, usePeriodFileByPeriodQuery } = sharingApi;
